module.exports = __webpack_public_path__ + "static/img/ejemplo_burbujas_1.2729758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ejemplo_burbujas_1.png
// module id = XGea
// module chunks = 1